module.exports = __webpack_public_path__ + "static/ev-williams-0465120cfef000ed327f91a8c1d0be77.jpg";